import { createStoryStreamAppConfig } from './storystream-fa-config/storystream-fa-config';

export const defaultAppConfig = {
  appsUMD: '/assets/storystream/storystream-umd.js',
  appsCommonsJS: '/assets/storystream/storystream-commonjs.js',
  appContent: null,
  createFunctionInstance: createStoryStreamAppConfig,
};
